import React from "react";
import "../Styles/MaintenanceSection.css";
import img from "../../Asserts/our9.png";
import { FaUserClock, FaClipboardCheck, FaBoxes, FaChalkboardTeacher, FaAward, FaIndustry, FaBalanceScale, FaHeartbeat, FaLaptopCode } from 'react-icons/fa';

const maintenanceItems = [
  { text: "Fast Response Team for unforeseen breakdown", icon: <FaUserClock /> },
  { text: "Scheduled inspection, testing, and analysis", icon: <FaClipboardCheck /> },
  { text: "On-site spares inventory management", icon: <FaBoxes /> },
  { text: "Seminars and knowledge sharing sessions", icon: <FaChalkboardTeacher /> },
  { text: "Service backed by warranty", icon: <FaAward /> },
  { text: "Experience from extensive installed base with diverse operating conditions", icon: <FaIndustry /> },
  { text: "Zero tolerance on ethics, integrity and compliance", icon: <FaBalanceScale /> },
  { text: "Condition monitoring and diagnostics (coming up shortly)", icon: <FaHeartbeat /> },
  { text: "Tech-enabled customized maintenance program (coming up shortly)", icon: <FaLaptopCode /> },
];

const MaintenanceSection = () => {
  return (
    <section className="maintenance-section">

      {/* Headings */}
      <div className="section-header">
        <h2 className="section-title">
          Keeping your equipment running longer
        </h2>
        <h3 className="section-subtitle">
          Efficiently and Safely
        </h3>
      </div>

      {/* Two Column Layout */}
      <div className="section-body">

        {/* Left Image */}
        <div className="section-image">
          <img
            src={img}
            alt="Maintenance Service"
          />
        </div>

        {/* Right Content */}
        <div className="section-content">
          <p>
            Blend with user’s maintenance team to ensure a safe, reliable and
            smart power management across the plant.
          </p>

          <ul>
            {maintenanceItems.map((item, index) => (
              <li key={index}><span className="maint-icon">{item.icon}</span>{item.text}</li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
};

export default MaintenanceSection;
